import { useState, useEffect } from "react";
import PageTitle from "./../../../components/common/pageTitle/PageTitle";
import { useNavigate } from "react-router-dom";
import { setHallStyleTypes } from "@src/@slice/recommendHallSlice";
import { useRecommendHall } from "./../../../utils/hooks/useRecommendHall";
import ImageSelectableCard from "@src/components/recommend/ImageSelectableCard";
import toast from "@src/utils/toast";

//이미지 파일들
import convention from "@assets/images/recommend/weddinghall/hall_convention.jpg";
import chapel from "@assets/images/recommend/weddinghall/hall_chapel.jpg";
import house from "@assets/images/recommend/weddinghall/hall_house.jpg";
import outdoors from "@assets/images/recommend/weddinghall/hall_outdoors.jpg";
import hotel from "@assets/images/recommend/weddinghall/hall_hotel.jpg";
import hanok from "@assets/images/recommend/weddinghall/hall_hanok.jpg";
import small from "@assets/images/recommend/weddinghall/hall_small.jpg";
import CustomHeader from "@src/components/common/appHeader/CustomHeader";
import StopRecommend from "./_component/StopRecommend";

export const styleItems = [
  { title: "컨벤션", subTitle: "화려하고 어두운 분위기", src: convention },
  { title: "채플", subTitle: "경건하고 우아한 우드톤", src: chapel },
  { title: "하우스", subTitle: "화사하고 이색적인 분위기", src: house },
  { title: "야외", subTitle: "자유로운 야외 파티 분위기", src: outdoors },
  { title: "호텔 예식", subTitle: "차별화된 프리미엄 웨딩", src: hotel },
  { title: "한옥", subTitle: "특별한 한국전통의 공간", src: hanok },
  { title: "소규모", subTitle: "소수 인원으로 집중된 공간", src: small },
];

const Style = () => {
  const navigate = useNavigate();
  const [validate, setValidate] = useState(false);
  const [showStopModal, setShowStopModal] = useState(false);
  const { dispatch, hallData } = useRecommendHall();

  useEffect(() => {
    toast.removeToast("recommendHallList");
  }, []);
  useEffect(() => {
    setValidate(hallData.hallStyleTypes.length > 0);
  }, [hallData.hallStyleTypes]);

  const goNext = () => {
    navigate("/recommend/hall/type");
  };

  return (
    <div className="recommend-hall-page recommend-hall-selection">
      <CustomHeader goBack={() => navigate("/recommend/hall/start")} close={() => setShowStopModal(true)} />
      <StopRecommend showStopModal={showStopModal} setShowStopModal={setShowStopModal} />
      <div className="recommend-hall-page-body">
        <PageTitle
          title={`선호하는 웨딩홀 스타일을
모두 선택해 주세요.`}
          type=""
        />
        <div className="recommend-hall-grid recommend-hall-grid--cols-2">
          {styleItems.map((item) => (
            <ImageSelectableCard
              key={`style-item-${item.title}`}
              src={item.src}
              checked={hallData.hallStyleTypes.indexOf(item.title) > -1}
              onClick={() => {
                dispatch(setHallStyleTypes({ type: item.title }));
              }}
            />
          ))}
        </div>
      </div>
      <div className="recommend-hall-page-footer">
        <button
          onClick={goNext}
          className={`btn btn-giant btn-red500 btn-full ${!validate ? "btn-disabled" : ""}`}
          disabled={!validate}
        >
          다음
        </button>
      </div>
    </div>
  );
};

export default Style;
